import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { pluck } from 'rxjs/operators';
const addPriceUnitMutation = gql`mutation addPriceUnit($priceUnit: price_units_insert_input!){
  insert_price_units_one(object: $priceUnit){
    id
    name
    created_at
    updated_at
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class AddPriceUnitService {

  constructor(
    private apollo: Apollo
  ) { }

  addPriceUnit(priceUnit: any){
    return this.apollo.use('external').mutate({
      mutation: addPriceUnitMutation,
      variables: {
        priceUnit
      }
    }).pipe(pluck('data', 'insert_price_units_one')).toPromise();
  }
}

